<template>
  <div>
    <div>
      <div class="text-center" v-if="loading" style="background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;width: 100%;height: 100%;position: absolute;display: block;z-index: 10002;margin: 0;top: 0;padding-top: 20%;">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Text Centered"></b-spinner> <br><span style="color:#004E86">Processando Aguarde...</span>
      </div>
      <b-modal ref="my-modal" size="lg" variant="primary" v-model="modalShow" title="Enviar para assinatura">
        <p><b>Outorgante:</b>
            A empresa {{ procuracao.outorgante_nome }} , CNPJ n.º {{ procuracao.outorgante_documento }},
            situada à {{ procuracao.outorgante_endereco }} - n.º {{ procuracao.outorgante_numero}},
            bairro {{ procuracao.outorgante_bairro }}, município {{ procuracao.outorgante_cidade }}, estado {{ procuracao.outorgante_uf }},
            CEP {{ procuracao.outorgante_cep }}, neste ato representada pelo CPF nº 276.648.698-46 e suas filiais constitui como seu(sua) bastante Procurador(a)
            (Outorgado) {{ procuracao.outorgado_nome }}, brasileiro(a), portador(a) do documento {{ procuracao.outorgado_documento }},
            residente e domiciliado(a) à {{ procuracao.outorgado_endereco }} - n.º {{ procuracao.outorgado_numero}},
            bairro {{ procuracao.outorgado_bairro }}, município {{ procuracao.outorgado_cidade }}, estado {{ procuracao.outorgado_uf }},
            CEP {{ procuracao.outorgado_cep }}, com poderes para representar o outorgante,
            no período de {{ procuracao.dt_vigencia_inicial }} a {{ procuracao.dt_vigencia_final }}, na utilização, por meio de certificado digital,
            dos serviços eletrônicos abaixo discriminados, disponibilizados pela Secretaria da Receita Federal do Brasil.</p>

        <p>
          <ul>
            <li style="list-style: none;" v-for="item in options" v-bind:key="item.value">
              <span v-for="serv in servicosEletronicos" :key="serv">
                <span v-if="serv == item.value">{{ item.text }}</span>
              </span>
            </li>
          </ul>
        </p>

        <p>SAO PAULO, 06 de Novembro de 2019.</p>

        <template v-slot:modal-footer="{ hide }">
          <b-button size="sm" variant="primary" @click="finalizar">
            Finalizar e enviar para processamento
          </b-button>
        </template>

      </b-modal>
    </div>
      <Header :home=false :logged="logged" />
        <div id="painel" class="container-fluid">
          <b-row>
              <b-col cols="12" md="4" lg="2" v-if="show" style="padding: 0;" >
                  <Menu class="d-none d-xl-block" />
              </b-col>
              <b-col cols="10" md="10" lg="10" class="flex">
                  <b-container fluid>
                      <b-form name="frmProcuracao" id="frmProcuracao">
                      <!-- <div class="d-lg-none">
                        <button class="mt-4" v-on:click="show = !show">
                            <font-awesome-icon size="1x" icon="bars" />
                        </button>
                      </div> -->

                      <h4 class="text-primary mt-5">Cadastro de Procuração</h4>
                      <hr>

                      <div>
                        <b-alert
                          :show="dismissCountDownSuc"
                          dismissible
                          variant="success"
                          @dismissed="dismissCountDownSuc=0"
                          @dismiss-count-down="countDownChanged"
                        >
                          Cadastrado com sucesso!
                        </b-alert>
                        <b-card border-variant="primary" header-text-variant="primary" header="Dados do Outorgante" >
                          <b-card-text>
                            <b-row>
                                <b-col cols="12" md="4" lg="6" >
                                    <label for="outorgante_nome">Nome</label>
                                    <b-input v-model="procuracao.outorgante_nome"  maxlength="100" placeholder="Nome completo" :state="validation_outorgante_nome" id="outorgante_nome" required></b-input>
                                    <b-form-invalid-feedback :state="validation_outorgante_nome">
                                        Infome o nome completo.
                                    </b-form-invalid-feedback>
                                    <b-form-valid-feedback :state="validation_outorgante_nome">
                                        campo checado.
                                    </b-form-valid-feedback>
                                </b-col>

                                <b-col cols="12" md="4" lg="4" >
                                    <label for="outorgante_email">Email</label>
                                    <b-input v-model="procuracao.outorgante_email"
                                      maxlength="100"
                                      type="email"
                                      placeholder="Email válido"
                                      :state="validation_outorgante_email"
                                      id="outorgante_email"
                                      required></b-input>
                                    <b-form-invalid-feedback :state="validation_outorgante_email">
                                        Email inválido.
                                    </b-form-invalid-feedback>
                                    <b-form-valid-feedback :state="validation_outorgante_email">
                                        campo checado.
                                    </b-form-valid-feedback>
                                </b-col>

                                <b-col cols="12" md="4" lg="2" >
                                    <label for="outorgante_documento">CPF/CNPJ</label><br>
                                    <span style="top: 7px;display: block;position: relative;">{{ procuracao.outorgante_documento | documento }}</span>
                                </b-col>
                            </b-row>
                            <b-row>
                              <b-col cols="12" md="12" lg="12" >
                                <h4 class="text-primary mt-5">Endereço</h4>
                                <hr>
                              </b-col>
                            </b-row>

                            <b-row>
                              <b-col cols="12" md="2" lg="2" >
                                  <label for="outorgante_cep">CEP</label>
                                  <b-input v-model="procuracao.outorgante_cep"
                                    maxlength="9"
                                    type="text"
                                    placeholder="_____-___"
                                    :state="validation_outorgante_cep"
                                    id="outorgante_cep"
                                    @keyup="cep"
                                    required></b-input>
                                  <b-form-invalid-feedback :state="validation_outorgante_cep">
                                      CEP inválido.
                                  </b-form-invalid-feedback>
                                  <b-form-valid-feedback :state="validation_outorgante_cep">
                                      campo checado.
                                  </b-form-valid-feedback>
                              </b-col>

                              <b-col cols="12" md="6" lg="6" >
                                  <label for="outorgante_endereco">Endereço</label>
                                  <b-input v-model="procuracao.outorgante_endereco"
                                    maxlength="100"
                                    type="text"
                                    placeholder="Endereço válido"
                                    :state="validation_outorgante_endereco"
                                    id="outorgante_endereco"
                                    required></b-input>
                                  <b-form-invalid-feedback :state="validation_outorgante_endereco">
                                      Endereço inválido.
                                  </b-form-invalid-feedback>
                                  <b-form-valid-feedback :state="validation_outorgante_endereco">
                                      campo checado.
                                  </b-form-valid-feedback>
                              </b-col>

                              <b-col cols="12" md="1" lg="1" >
                                  <label for="outorgante_numero">Nº</label>
                                  <b-input v-model="procuracao.outorgante_numero"
                                    maxlength="100"
                                    type="text"
                                    placeholder="0"
                                    :state="validation_outorgante_numero"
                                    id="outorgante_numero"
                                    required></b-input>
                                  <b-form-invalid-feedback :state="validation_outorgante_numero">
                                      Número inválido.
                                  </b-form-invalid-feedback>
                                  <b-form-valid-feedback :state="validation_outorgante_numero">
                                      campo checado.
                                  </b-form-valid-feedback>
                              </b-col>

                              <b-col cols="12" md="1" lg="3" >
                                  <label for="outorgante_complemento">Complemento</label>
                                  <b-input v-model="procuracao.outorgante_complemento"
                                    maxlength="100"
                                    type="text"
                                    placeholder="Complemento"
                                    id="outorgante_complemento"
                                    required></b-input>
                                  <b-form-invalid-feedback>
                                      Complemento.
                                  </b-form-invalid-feedback>
                                  <b-form-valid-feedback >
                                      campo checado.
                                  </b-form-valid-feedback>
                              </b-col>

                            </b-row>

                            <b-row>
                              <b-col cols="12" md="5" lg="5" >
                                <label for="outorgante_cidade">Cidade</label>
                                <b-input v-model="procuracao.outorgante_cidade"
                                  maxlength="100"
                                  type="text"
                                  placeholder="0"
                                  :state="validation_outorgante_cidade"
                                  id="outorgante_cidade"
                                  required></b-input>
                                <b-form-invalid-feedback :state="validation_outorgante_cidade">
                                    Informe a Cidade.
                                </b-form-invalid-feedback>
                                <b-form-valid-feedback :state="validation_outorgante_cidade">
                                    campo checado.
                                </b-form-valid-feedback>
                              </b-col>

                              <b-col cols="12" md="6" lg="6" >
                                      <label for="outorgante_bairro">Bairro</label>
                                      <b-input v-model="procuracao.outorgante_bairro"
                                        maxlength="100"
                                        type="text"
                                        placeholder="0"
                                        :state="validation_outorgante_bairro"
                                        id="outorgante_bairro"
                                        required></b-input>
                                      <b-form-invalid-feedback :state="validation_outorgante_bairro">
                                          Informe o Bairro.
                                      </b-form-invalid-feedback>
                                      <b-form-valid-feedback :state="validation_outorgante_bairro">
                                          campo checado.
                                      </b-form-valid-feedback>
                              </b-col>

                              <b-col cols="12" md="1" lg="1" >
                                      <label for="outorgante_uf">UF</label>
                                      <b-input v-model="procuracao.outorgante_uf"
                                        maxlength="100"
                                        type="text"
                                        placeholder="0"
                                        :state="validation_outorgante_uf"
                                        id="outorgante_uf"
                                        required></b-input>
                                      <b-form-invalid-feedback :state="validation_outorgante_uf">
                                          Informe a UF .
                                      </b-form-invalid-feedback>
                                      <b-form-valid-feedback :state="validation_outorgante_uf">
                                          campo checado.
                                      </b-form-valid-feedback>
                              </b-col>
                            </b-row>

                          </b-card-text>
                        </b-card>
                      </div>

                      <br>
                      <!-- inicio cadastro do outorgado procurador-->
                      <div>
                        <b-card border-variant="primary" header-text-variant="primary" header="Dados do Outorgado (Procurador)" >
                          <b-card-text>
                            <b-row>
                                <b-col cols="12" md="4" lg="6" >
                                        <label for="outorgado_nome">Nome</label>
                                        <b-input v-model="procuracao.outorgado_nome" maxlength="100" placeholder="Nome completo" :state="validation_outorgado_nome" id="outorgado_nome" required></b-input>
                                        <b-form-invalid-feedback :state="validation_outorgado_nome">
                                            Infome o nome completo.
                                        </b-form-invalid-feedback>
                                        <b-form-valid-feedback :state="validation_outorgado_nome">
                                            campo checado.
                                        </b-form-valid-feedback>
                                </b-col>

                                <b-col cols="12" md="4" lg="4" >
                                        <label for="outorgado_email">Email</label>
                                        <b-input v-model="procuracao.outorgado_email"
                                          maxlength="100"
                                          type="email"
                                          placeholder="Email válido"
                                          :state="validation_outorgado_email"
                                          id="outorgado_email"
                                          required></b-input>
                                        <b-form-invalid-feedback :state="validation_outorgado_email">
                                            Email inválido.
                                        </b-form-invalid-feedback>
                                        <b-form-valid-feedback :state="validation_outorgado_email">
                                            campo checado.
                                        </b-form-valid-feedback>
                                </b-col>

                                <b-col cols="12" md="4" lg="2" >
                                  <b-alert style="display: block;position: absolute;"
                                    :show="dismissCountDownDOC"
                                    dismissible
                                    variant="danger"
                                    @dismissed="dismissCountDownDOC=0"
                                    @dismiss-count-down="countDownChanged"
                                  >
                                    DOCUMENTO INVÁLIDO!
                                  </b-alert>
                                      <label for="outorgado_documento"> CPF/CNPJ</label>
                                      <b-input
                                        v-model="procuracao.outorgado_documento"
                                        placeholder="Documento"
                                        maxlength="18"
                                        :state="validation_outorgado_documento"
                                        id="outorgado_documento"
                                        @keyup="documento"
                                        @blur="validarDocumento"
                                        required>
                                      </b-input>
                                      <b-form-invalid-feedback :state="validation_outorgado_documento">
                                          Infome o documento.
                                      </b-form-invalid-feedback>
                                      <b-form-valid-feedback :state="validation_outorgado_documento">
                                          campo checado.
                                      </b-form-valid-feedback>
                                </b-col>
                            </b-row>
                            <b-row>
                              <b-col cols="12" md="12" lg="12" >
                                <h4 class="text-primary mt-5">Endereço</h4>
                                <hr>
                              </b-col>
                            </b-row>

                            <b-row>
                              <b-col cols="12" md="2" lg="2" >
                                      <label for="outorgado_cep">CEP</label>
                                      <b-input v-model="procuracao.outorgado_cep"
                                        maxlength="9"
                                        type="text"
                                        placeholder="_____-___"
                                        :state="validation_outorgado_cep"
                                        id="outorgado_cep"
                                        @keyup="cep"
                                        required></b-input>
                                      <b-form-invalid-feedback :state="validation_outorgado_cep">
                                          CEP inválido.
                                      </b-form-invalid-feedback>
                                      <b-form-valid-feedback :state="validation_outorgado_cep">
                                          campo checado.
                                      </b-form-valid-feedback>
                              </b-col>

                              <b-col cols="12" md="6" lg="6" >
                                      <label for="outorgado_endereco">Endereço</label>
                                      <b-input v-model="procuracao.outorgado_endereco"
                                        maxlength="100"
                                        type="text"
                                        placeholder="Endereço válido"
                                        :state="validation_outorgado_endereco"
                                        id="outorgado_endereco"
                                        required></b-input>
                                      <b-form-invalid-feedback :state="validation_outorgado_endereco">
                                          Endereço inválido.
                                      </b-form-invalid-feedback>
                                      <b-form-valid-feedback :state="validation_outorgado_endereco">
                                          campo checado.
                                      </b-form-valid-feedback>
                              </b-col>

                              <b-col cols="12" md="1" lg="1" >
                                      <label for="outorgado_numero">Nº</label>
                                      <b-input v-model="procuracao.outorgado_numero"
                                        maxlength="100"
                                        type="text"
                                        placeholder="0"
                                        :state="validation_outorgado_numero"
                                        id="outorgado_numero"
                                        required></b-input>
                                      <b-form-invalid-feedback :state="validation_outorgado_numero">
                                          Número inválido.
                                      </b-form-invalid-feedback>
                                      <b-form-valid-feedback :state="validation_outorgado_numero">
                                          campo checado.
                                      </b-form-valid-feedback>
                              </b-col>

                              <b-col cols="12" md="1" lg="3" >
                                      <label for="outorgado_complemento">Complemento</label>
                                      <b-input v-model="procuracao.outorgado_complemento"
                                        maxlength="100"
                                        type="text"
                                        placeholder="Complemento"
                                        id="outorgado_complemento"
                                        required></b-input>
                                      <b-form-invalid-feedback>
                                          Complemento.
                                      </b-form-invalid-feedback>
                                      <b-form-valid-feedback >
                                          campo checado.
                                      </b-form-valid-feedback>
                              </b-col>

                            </b-row>

                            <b-row>
                              <b-col cols="12" md="5" lg="5" >
                                      <label for="outorgado_cidade">Cidade</label>
                                      <b-input v-model="procuracao.outorgado_cidade"
                                        maxlength="100"
                                        type="text"
                                        placeholder="0"
                                        :state="validation_outorgado_cidade"
                                        id="outorgante_cidade"
                                        required></b-input>
                                      <b-form-invalid-feedback :state="validation_outorgado_cidade">
                                          Informe a Cidade.
                                      </b-form-invalid-feedback>
                                      <b-form-valid-feedback :state="validation_outorgado_cidade">
                                          campo checado.
                                      </b-form-valid-feedback>
                              </b-col>

                              <b-col cols="12" md="6" lg="6" >
                                      <label for="outorgado_bairro">Bairro</label>
                                      <b-input v-model="procuracao.outorgado_bairro"
                                        maxlength="100"
                                        type="text"
                                        placeholder="0"
                                        :state="validation_outorgado_bairro"
                                        id="outorgado_bairro"
                                        required></b-input>
                                      <b-form-invalid-feedback :state="validation_outorgado_bairro">
                                          Informe o Bairro.
                                      </b-form-invalid-feedback>
                                      <b-form-valid-feedback :state="validation_outorgado_bairro">
                                          campo checado.
                                      </b-form-valid-feedback>
                              </b-col>

                              <b-col cols="12" md="1" lg="1" >
                                      <label for="outorgado_uf">UF</label>
                                      <b-input v-model="procuracao.outorgado_uf"
                                        maxlength="100"
                                        type="text"
                                        placeholder="0"
                                        :state="validation_outorgado_uf"
                                        id="outorgado_uf"
                                        required></b-input>
                                      <b-form-invalid-feedback :state="validation_outorgado_uf">
                                          Informe a UF .
                                      </b-form-invalid-feedback>
                                      <b-form-valid-feedback :state="validation_outorgado_uf">
                                          campo checado.
                                      </b-form-valid-feedback>
                              </b-col>
                            </b-row>

                          </b-card-text>
                        </b-card>
                      </div>

                      <br>
                      <div>
                        <b-card border-variant="primary" header-text-variant="primary" header="Dados da Procuração" >
                          <b-card-text>
                            <b-row>
                                <b-col cols="12" md="4" lg="3" >
                                        <label for="dt_vigencia_inicial">Data Inicial Vigência</label>
                                        <b-input v-model="procuracao.dt_vigencia_inicial"
                                        disabled
                                        id="dt_vigencia_inicial"
                                        required></b-input>
                                </b-col>
                                <b-col cols="12" md="4" lg="3" >
                                        <label for="dt_vigencia_final">Data Final Vigência</label>
                                        <b-input v-model="procuracao.dt_vigencia_final"
                                        type="date"
                                        placeholder="__/__/____"
                                        :state="validation_dt_vigencia_final"
                                        id="dt_vigencia_final" required></b-input>
                                        <b-form-invalid-feedback :state="validation_dt_vigencia_final">
                                            Infome o nome completo.
                                        </b-form-invalid-feedback>
                                        <b-form-valid-feedback :state="validation_dt_vigencia_final">
                                            campo checado.
                                        </b-form-valid-feedback>
                                </b-col>

                            </b-row>
                            <b-row>
                              <b-col cols="12" md="12" lg="12" >
                                <h4 class="text-primary mt-5">Opções de Atendimento Permitidas para Delegante Pessoa Jurídica:</h4>
                                <hr>
                                <b-form-group label="Selecione as opções">
                                  <b-form-checkbox-group
                                    id="checkbox-group-1"
                                    v-model="servicosEletronicos"
                                    :options="options"
                                    name="flavour-1"
                                  ></b-form-checkbox-group>
                                </b-form-group>
                              </b-col>
                            </b-row>

                          </b-card-text>
                        </b-card>
                        <br>
                        <b-row>
                          <b-col cols="12" md="12" lg="12" >
                            <div>
                               <b-alert
                                 :show="dismissCountDown"
                                 dismissible
                                 variant="danger"
                                 @dismissed="dismissCountDown=0"
                                 @dismiss-count-down="countDownChanged"
                               >
                                 Preencha todos os campos obrigatórios!
                               </b-alert>
                             </div>
                            <b-button block variant="primary" type="button" @click="assinar" >Assinar o documento</b-button>
                          </b-col>
                        </b-row>
                        <br><br><br><br>

                      </div>
                    </b-form>

                  </b-container>
              </b-col>
          </b-row>
      </div>
    </div>
</template>

<script>
    import axios from "axios"
    import Header from '../../components/Header'
    import API from '../../services/api'
    import Menu from '../../template/Menu'
    //import Modal from '../../components/modal/Confmodal'


    export default {
        components: {
            Header,
            Menu,
          //Modal,
        },
        data() {
            return {
              dismissSecs: 5,
              dismissCountDown: 0,
              dismissCountDownDOC: 0,
              dismissCountDownSuc: 0,
              arquivosCertidao: [],
              loading: false,
              show: true,
              procuracao:{},
              message: '',
              servicosEletronicos: [], // Must be an array reference!
              options: [],
              erro: false,
              modalShow: false,
              newWindow: '',
              cd_procuracao : ''
            }
        },
        computed: {
          validation_outorgante_nome() {
            if(this.procuracao.outorgante_nome != undefined) {
              var out_nome = this.procuracao.outorgante_nome
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          },
          validation_outorgado_nome() {
            if(this.procuracao.outorgado_nome != undefined) {
              var out_nome = this.procuracao.outorgado_nome
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          },
          validation_outorgante_bairro() {
            if(this.procuracao.outorgante_bairro!= undefined) {
              var out_nome = this.procuracao.outorgante_bairro
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          },
          validation_outorgado_bairro() {
            if(this.procuracao.outorgado_bairro!= undefined) {
              var out_nome = this.procuracao.outorgado_bairro
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          },
          validation_outorgante_cidade() {
            if(this.procuracao.outorgante_cidade != undefined) {
              var out_nome = this.procuracao.outorgante_cidade
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          },
          validation_outorgado_cidade() {
            if(this.procuracao.outorgado_cidade != undefined) {
              var out_nome = this.procuracao.outorgado_cidade
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          },
          validation_outorgante_uf() {
            if(this.procuracao.outorgante_uf != undefined) {
              var out_nome = this.procuracao.outorgante_uf
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          },
          validation_outorgado_uf() {
            if(this.procuracao.outorgado_uf != undefined) {
              var out_nome = this.procuracao.outorgado_uf
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          },
          validation_outorgante_numero() {
            if(this.procuracao.outorgante_numero != undefined) {
              var out_nome = this.procuracao.outorgante_numero
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          },
          validation_outorgado_numero() {
            if(this.procuracao.outorgado_numero != undefined) {
              var out_nome = this.procuracao.outorgado_numero
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          },
          validation_outorgante_documento() {
            if(this.procuracao.outorgante_documento != undefined)
              return this.procuracao.outorgante_documento.length > 0 && this.procuracao.outorgante_documento != ''
            else
              return false
          },
          validation_outorgado_documento() {
            if(this.procuracao.outorgado_documento != undefined)
              return this.procuracao.outorgado_documento.length > 0 && this.procuracao.outorgado_documento != ''
            else
              return false
          },
          validation_outorgante_email() {
            if(this.procuracao.outorgante_email != undefined){
              /* eslint-disable */
              var er = /^[a-zA-Z0-9][a-zA-Z0-9\._-]+@([a-zA-Z0-9\._-]+\.)[a-zA-Z-0-9]{2,3}/;
              if( !er.exec(this.procuracao.outorgante_email) )
                return false;
              else
                return this.procuracao.outorgante_email.length > 0 && this.procuracao.outorgante_email != ''
            }else
              return false
          },
          validation_outorgado_email() {
            if(this.procuracao.outorgado_email != undefined){
              /* eslint-disable */
              var er = /^[a-zA-Z0-9][a-zA-Z0-9\._-]+@([a-zA-Z0-9\._-]+\.)[a-zA-Z-0-9]{2,3}/;
              if( !er.exec(this.procuracao.outorgado_email) )
                return false;
              else
                return this.procuracao.outorgado_email.length > 0 && this.procuracao.outorgado_email != ''
            }else
              return false
          },
          validation_outorgante_cep() {
            if(this.procuracao.outorgante_cep != undefined) {
              var dados = this.procuracao.outorgante_cep
              var dadosLimpo = dados.trim()
              return dadosLimpo.length > 0
            }else
              return false
          },
          validation_outorgado_cep() {
            if(this.procuracao.outorgado_cep != undefined) {
              var dados = this.procuracao.outorgado_cep
              var dadosLimpo = dados.trim()
              return dadosLimpo.length > 0
            }else
              return false
          },
          validation_outorgante_endereco() {
            if(this.procuracao.outorgante_endereco != undefined) {
              var out_nome = this.procuracao.outorgante_endereco
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          },
          validation_outorgado_endereco() {
            if(this.procuracao.outorgado_endereco != undefined) {
              var out_nome = this.procuracao.outorgado_endereco
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          },
          validation_dt_vigencia_final() {
            if(this.procuracao.dt_vigencia_final!= undefined) {
              var out_nome = this.procuracao.dt_vigencia_final
              var nomeLimpo = out_nome.trim()
              return nomeLimpo.length > 0
            }else
              return false
          }
        },
        filters: {
          documento: function (value) {
            if (value == null) {
                return '';
            } else {
                let v = value;
                //Remove tudo o que não é dígito
                v = v.replace(/\D/g, "");
                if (v.length < 14) { //CPF
                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d)/, "$1.$2");
                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    //de novo (para o segundo bloco de números)
                    v = v.replace(/(\d{3})(\d)/, "$1.$2");
                    //Coloca um hífen entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                } else { //CNPJ
                    //Coloca ponto entre o segundo e o terceiro dígitos
                    v = v.replace(/^(\d{2})(\d)/, "$1.$2");
                    //Coloca ponto entre o quinto e o sexto dígitos
                    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                    //Coloca uma barra entre o oitavo e o nono dígitos
                    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
                    //Coloca um hífen depois do bloco de quatro dígitos
                    v = v.replace(/(\d{4})(\d)/, "$1-$2");
                }
                return v;
            }
          },
          dataHora: function (value) {
            if (value !== "" && value !== undefined && value !== null){
            let date = new Date(value);
            return date.toLocaleDateString("pt-BR", {
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric'
                });
            }
            return "";
          },
          Celular: function (value){
            var d = value
            d = d.replace(/\D/g, "")
            d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
            d = d.replace(/(\d{5})(\d)/, "$1-$2")
            return d
          },
          Telefone: function (value){
            var d = value
            d = d.replace(/\D/g, "")
            d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
            d = d.replace(/(\d{4})(\d)/, "$1-$2")
            return d
          },
          Moeda: function (v){
            /*var p = v.indexOf(".");
            v = v.slice(0, (p+3))
            v = v.replace(/\D/g,'');
            v = (v/100).toFixed(2) + '';
            */
            v = v.toString().replace(".", ",");
            v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
            v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
            return 'R$ ' + v;
          }
        },
        created: function() {
           //localStorage.setItem('cd_procuracao', 121)
          if(localStorage.getItem('libAnuenciaProc') == true)this.$router.push({name: "painel"});
          this.getDados();
          this.logged = true
          this.procuracao.outorgante_documento = localStorage.getItem("usrCpf")
          this.procuracao.outorgante_nome = localStorage.getItem("usrName")
          this.procuracao.outorgante_email = localStorage.getItem("usrEmail")
        },
        methods: {
          finalizar() {
            //esconde modal
            // this.$refs['my-modal'].hide()
            //organizar os dados
            this.loading = true;
            this.procuracao.servicosEletronicos = []
            this.procuracao.servicosEletronicos.push({'servicos':this.servicosEletronicos})
            //console.log(this.procuracao)
            //gravar dados
            let self = this
            const token = localStorage.getItem('jwtToken')
             this.procuracao.sha256 = localStorage.getItem("nm_thumbprint_sha256")
            //this.procuracao.sha256 = 'dWi9NBFVlLPGw6S8BfUtYYN5E2aDp0k7l3unL5Jtn0g='

            API.post(`procuracao/cadastrar/?token=${token}`, this.procuracao).then((res) => {
              //console.log(res.data)
                this.abreJanAssinador(res.data.cd_assinador_lacuna,res.data.token)
                this.cd_procuracao = res.data.cd_procuracao;
                //self.loading = false;

              //const linkSource = `data:application/pdf;base64,${res.data}`;
              //const downloadLink = document.createElement("a");
              //const fileName = "vct_illustration.pdf";

              //downloadLink.href = linkSource;
              //downloadLink.download = fileName;
              //downloadLink.click();
            })

          },
          abreJanAssinador(cd_assinador_lacuna, token){
            this.PopupCenter(process.env.VUE_APP_siteAssinador+"/pki/assinarCadesPades.php?token="+token+"&nm_tipo_assinatura=pades", "janAssinador", 500, 300);
            this.checaSeAssinou(cd_assinador_lacuna, token);
          },
          PopupCenter(url, title, w, h) {
          		// Fixes dual-screen position                         Most browsers      Firefox
          		var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
          		var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

          		var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
          		var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

          		var systemZoom = width / window.screen.availWidth;
          		var left = (width - w) / 2 / systemZoom + dualScreenLeft
          		var top = (height - h) / 2 / systemZoom + dualScreenTop
          		var newWindo = window.open(url, title, 'scrollbars=yes, width=' + w / systemZoom + ', height=' + h / systemZoom + ', top=' + top + ', left=' + left);
              this.newWindow = newWindo
          		// Puts focus on the newWindow
              if(this.newWindow !==  null)
          		  if (window.focus) this.newWindow.focus();
          	},
            async checaSeAssinou(cd_assinador_lacuna, token){
              var self = this
              const tokem = localStorage.getItem('jwtToken')
              const res = await API.get(`procuracao/assinar/checar/${cd_assinador_lacuna}/?token=${tokem}`)
              if(res.data[0] == 1) {
                alert('assinado com sucesso!')
                self.modalShow = false;
                self.loading = false;
                await API.put(`procuracao/atualizaStatus/${self.cd_procuracao}/2?token=${tokem}`)
                localStorage.setItem('cd_procuracao', self.cd_procuracao)
                self.$router.push({name: 'procuracaoPesquisar'});
                //self.$router.push({name:'procuracao/'+ self.cd_procuracao})
              } else {
                var timerSeAssinou = setTimeout(function(){ self.checaSeAssinou(cd_assinador_lacuna, token); }, 2000);
                if(self.newWindow.closed){
                  self.PopupCenter(process.env.VUE_APP_siteAssinador+"/pki/assinarCadesPades.php?token="+token+"&nm_tipo_assinatura=pades", "janAssinador", 500, 300);
                  clearTimeout(timerSeAssinou);
                }
              }
          },
          countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
          },
          assinar(){
            if(this.validar() == false){
              this.modalShow = !this.modalShow
            }
          },
          validarCPF(cpf) {
              var validar = "false";
               cpf = cpf.replace(/[^\d]+/g,'');
              if(cpf == ''){ // return false
              validar = "true";
          }else
              // Elimina CPFs invalidos conhecidos
              if (cpf.length != 11 ||
                  cpf == "00000000000" ||
                  cpf == "11111111111" ||
                  cpf == "22222222222" ||
                  cpf == "33333333333" ||
                  cpf == "44444444444" ||
                  cpf == "55555555555" ||
                  cpf == "66666666666" ||
                  cpf == "77777777777" ||
                  cpf == "88888888888" ||
                  cpf == "99999999999")
                     // return false;
                     validar = "true";
              // Valida 1o digito
              var add = 0;
              var i;
              var rev;
              for (i=0; i < 9; i ++)
                  add += parseInt(cpf.charAt(i)) * (10 - i);
                  rev = 11 - (add % 11);
                  if (rev == 10 || rev == 11)
                      rev = 0;
                  if (rev != parseInt(cpf.charAt(9)))
                     validar = "true";
                      //return false;
              // Valida 2o digito
              add = 0;
              for (i = 0; i < 10; i ++)
                  add += parseInt(cpf.charAt(i)) * (11 - i);
              rev = 11 - (add % 11);
              if (rev == 10 || rev == 11)
                  rev = 0;
              if (rev != parseInt(cpf.charAt(10)))
                  validar = "true";
                  //return false;

              if(validar == "true"){
                this.$set(this.procuracao,'outorgado_documento','')
                this.dismissCountDownDOC = this.dismissSecs
                return false;
              }else{
                return true;
              }

          },
          VerificaCNPJ(V_CNPJ) {
              var CNPJ1;
              var CNPJ;
              var i, y, x;
              CNPJ1 = V_CNPJ;
              CNPJ = CNPJ1.trim();

              if (!(CNPJ.length== 18 || CNPJ.length == 14)){
                      //return false;
                      this.$set(this.procuracao,'outorgado_documento','')
                      this.dismissCountDownDOC = this.dismissSecs
              }else{
                  //substituir os caracteres que nao sao numeros
                  CNPJ = CNPJ.replace(/[.,\/-]/g,""); //tanks eclesiastes ;)
                  var nonNumbers = /\D/;
                  if (nonNumbers.test(CNPJ)){
                         // return false;
                         this.$set(this.procuracao,'outorgado_documento','')
                         this.dismissCountDownDOC = this.dismissSecs
                  }
                  var a = [];
                  var b = new Number;
                  var c = [6,5,4,3,2,9,8,7,6,5,4,3,2];
                  for (i=0; i<12; i++){
                          a[i] = CNPJ.charAt(i);
                          b += a[i] * c[i+1];
                  }
                  if ((x = b % 11) < 2) {a[12] = 0;} else {a[12] = 11-x;}
                  b = 0;
                  for (y=0; y<13; y++) {
                          b += (a[y] * c[y]);
                  }
              }
              if ((x = b % 11) < 2) {a[13] = 0;} else {a[13] = 11-x;}
              if ((CNPJ.charAt(12) != a[12]) || (CNPJ.charAt(13) != a[13])){
                              //return false;
                              this.$set(this.procuracao,'outorgado_documento','')
                              this.dismissCountDownDOC = this.dismissSecs
              }
              return true;
          },
          validar: function(){
            //validar o formulario
            var inputs = document.getElementById("frmProcuracao").getElementsByTagName("input")
            var i;
            for (i = 0; i < inputs.length; i++) {
              if((document.getElementById("frmProcuracao").getElementsByTagName("input")[i].id != 'outorgado_complemento') &&
              (document.getElementById("frmProcuracao").getElementsByTagName("input")[i].id != 'outorgante_complemento')){
                if(document.getElementById("frmProcuracao").getElementsByTagName("input")[i].value.trim() == ""){
                  this.erro = true
                  this.dismissCountDown = this.dismissSecs
                } else {
                  this.erro = false
                }
              }
            }
            if (this.servicosEletronicos.length == '0'){
              this.dismissCountDown = this.dismissSecs
              this.erro = true
            } else {
              this.erro = false
            }
            return this.erro

          },
          async getDados() {
            this.loading = false
            var  self = this
            const token = localStorage.getItem('jwtToken')
            const res = await API.get(`procuracao/cadastro/?token=${token}`)
            self.$set(self.procuracao,'dt_vigencia_inicial',res.data.dt_vigencia_inicial)
            var i;
            for (i = 0; i < res.data.servicosEletronicos.length; i++) {
                self.options.push({'text': res.data.servicosEletronicos[i].descricao , 'value':res.data.servicosEletronicos[i].id })
            }
            this.loading = false
          },
          validarDocumento: function (event) {
            if(event.target.value.length > '14'){
              //valida cnpj
              this.VerificaCNPJ(event.target.value)
            }else{
              //valida cpf
              this.validarCPF(event.target.value)
            }
          },
          cep: function (event){
            var d = event.target.value
            d = d.replace(/\D/g, "")
            d = d.replace(/^(\d{5})(\d)/, "$1-$2")
            event.target.value = d
            if (d.length == 9) {
              this.BuscarCep(d,event.target.id)
            }
          },
          documento: function (event) {
            var value = event.target.value
            if (value == null) {
                return '';
            } else {
                let v = value;
                //Remove tudo o que não é dígito
                v = v.replace(/\D/g, "");
                if (v.length < 14) { //CPF
                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d)/, "$1.$2");
                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    //de novo (para o segundo bloco de números)
                    v = v.replace(/(\d{3})(\d)/, "$1.$2");
                    //Coloca um hífen entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                } else { //CNPJ
                    //Coloca ponto entre o segundo e o terceiro dígitos
                    v = v.replace(/^(\d{2})(\d)/, "$1.$2");
                    //Coloca ponto entre o quinto e o sexto dígitos
                    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                    //Coloca uma barra entre o oitavo e o nono dígitos
                    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
                    //Coloca um hífen depois do bloco de quatro dígitos
                    v = v.replace(/(\d{4})(\d)/, "$1-$2");
                }
                event.target.value = v;
            }
          },
         BuscarCep: function(cep, id){
            var cepl = cep.replace("-","");
            var self = this;
            try{
                axios.get(`https://viacep.com.br/ws/${cepl}/json/`).then(resp => {
                  if (resp.data.erro == true) {
                    this.message = "Cep não encontrado."
                  } else {
                    if(id == 'outorgante_cep'){
                      self.$set(self.procuracao,'outorgante_endereco',resp.data.logradouro)
                      self.$set(self.procuracao,'outorgante_bairro',resp.data.bairro)
                      self.$set(self.procuracao,'outorgante_cidade',resp.data.localidade)
                      self.$set(self.procuracao,'outorgante_uf',resp.data.uf)
                      self.$set(self.procuracao,'outorgante_complemento',resp.data.complemento)
                      self.$set(self.procuracao,'outorgante_ibge',resp.data.ibge)
                      document.getElementById("outorgante_numero").focus()
                    }else{
                      self.$set(self.procuracao,'outorgado_endereco',resp.data.logradouro)
                      self.$set(self.procuracao,'outorgado_bairro',resp.data.bairro)
                      self.$set(self.procuracao,'outorgado_cidade',resp.data.localidade)
                      self.$set(self.procuracao,'outorgado_uf',resp.data.uf)
                      self.$set(self.procuracao,'outorgado_complemento',resp.data.complemento)
                      self.$set(self.procuracao,'outorgado_ibge',resp.data.ibge)
                      document.getElementById("outorgado_numero").focus()
                    }
                  }
                }).catch(() => {
                  console.error('error')
                })
            }catch(error){
                console.error('error')
            }finally{
                console.error('error')
            }
        }
      }
    }
</script>

<style scoped>
#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}
    #painel {
        position: fixed;
        width: 100%;
        left: 0px;
        bottom: 0px;
        padding-top: 0px;
        height: calc(100% - 80px);
        overflow-x: hidden;
    border-top: 1px solid #f1f1f1;
    }
    .lista-certidoes {
        color: #000;
    }
    .lista-certidoes b {
        font-size: 0.85rem;
        color: var(--main-azul);
    }

    a {
        color: #555;
    }
    .shadow {
        box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
    }
    #loading-solicitante {
        vertical-align: 0;
        margin-left: -21px;
    }
    .load{
        top: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .spin {
        background: #fff;
        height: 80px;
        width: 80px;
        border-radius: 50vh;
        border-color: #209CEE;
        border-top: 5px solid  #209CEE;
        animation: loading 3s linear infinite;
    }
    .loading{
        position: absolute;
        color: #000;
    } @keyframes loading{
        100%{
            transform: rotate(360deg)
        }
    }
    .bold{
    font-weight: bold;
    }
    .mensagemErro{
      color: red;
    }
    #cabecalho{
      z-index: 0 !important;
    }
</style>
